<template>
  <div class="login wrapper fadeInDown">
    <div id="formContent">
      <!-- Icon -->
      <div class="fadeIn first">
        <img
          v-loading="loading"
          :src="logo"
          style="width: 50%; margin-top: 2vh;"
          draggable="false"
          id="icon"
          alt="User Icon"
        />
        <br />
        <br />
        <span class="h3">SISTEMA DE GERENCIAMENTO DE</span>
        <br />
        <span class="h3">VENDAS</span>
      </div>

      <form class="row form-signin" @submit.prevent="signin">
        <div></div>
        <div class="form-group col-12">
          <div class="alert alert-danger" v-if="error">{{ error }}</div>
          <input
            v-model="cpf"
            type="text"
            class="form-control fadeIn second"
            id="cpf"
            v-mask="'###.###.###-##'"
            placeholder="CPF"
          />
        </div>
        <div class="form-group col-12">
          <PasswordInput
            v-model="password"
            id="password"
            placeholder="Senha"
            label=""
          />
        </div>
        <div class="col-12">
          <button id="login-button" type="submit" class="btn btn-info mb-3 fadeIn fourth">
            Login
          </button>
        <!-- Remind Passowrd -->
          <div id="formFooter" class="col-12">
             <router-link v-if="$route.path !== '/recuperacaoConta'" class="underlineHover" to="/recuperacaoConta">
              Esqueci a senha
             </router-link>
             <br>
             <a class="underlineHover" href="/politica-de-privacidade-vegetal-agronegocios.html">Política de Privacidade</a>
          </div>
        </div>
        <div class="rowCaptcha">
          <img :src="`data:image/png;base64,${captcha.image}`" />
          <input
            v-model="captcha.response"
            type="text"
            class="form-control"
            id="captcha-response"
            placeholder="Resultado da soma"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import myCaptcha from "vue-captcha";
import Axios from "axios";
import PasswordInput from "../../components/Inputs/PasswordInput.vue";

export default {
  name: "Login",
  data() {
    return {
      cpf: "",
      password: "",
      error: "",
      captchaOK: false,
      captcha: {
        response: ''
      },
      loading: true,
    };
  },
  created() {
    this.checkSignedIn();
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    },
    logo() {
      if (this.loading) return "";

      return this.setting_image.logo_sgv && this.setting_image.logo_sgv.value
        ? this.setting_image.logo_sgv.value
        : "/img/brand/top-logo.png";
    }
  },
  mounted(){
    this.getCaptcha()
  },
  methods: {
    captchaAproved() {
      this.captchaOK = true;
    },
    captchaBtn() {
      this.btndis = false;
    },
    clicked() {
      alert("button active.!");
    },
    signin() {
      if (this.captcha.response && this.captcha.response.length) {
        this.$updateUser({}); // Fix user authentication

        this.$http
          .plain({
            method: "post",
            url: "api/v1/login",
            data: {
              user: {
                cpf: this.cpf, password: this.password
              },
              captcha: {
                response: this.captcha.response,
                hash: this.captcha.hash
              }
            }
          })
          .then((response) => this.signinSuccessful(response))
          .catch((error) => this.signinFailed(error));
      } else {
        this.$toasted.global.defaultError({
          msg: "Por gentileza, responda o Recaptcha",
        });
      }
    },
    signinSuccessful(response) {
      this.$updateUser(response.data);
      this.$router.push("/").catch((error) => {
        console.info("mensagem de erro: ", error.message);
      });
    },
    signinFailed(error) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        "";
      let msg = (error.response && error.response.data && error.response.data.errors) ?
        error.response.data.errors :
        "Login ou senha inválidos"
      delete localStorage.csrf;
      delete localStorage.signedIn;
      this.$toasted.global.defaultError({ msg: msg });
    },
    checkSignedIn() {
      if (localStorage.currentUser) {
        this.$router.replace({ path: "/" });
      }
    },
    getCaptcha() {
      this.$http
        .plain({
          method: "get",
          url: "api/v1/login"
        })
        .then((response) => {
          this.captcha = response.data.captcha 
        })
    }
  },
  watch: {
    setting_image: {
      handler() {
        this.loading = false;
      },
      deep: true,
      immediate: true,
    }
  },
  components: {
    "my-captcha": myCaptcha,
    PasswordInput,
  },
};
</script>

<style lang="scss">
.login .form-signin {
  width: 90%;
  max-width: 500px;
  // padding: 10% 15px;
  margin: 0 auto;
  // position: relative;
  margin-top: 12px;

}
.rowCaptcha {
  width: 385px;
  height: 160px;
  margin: auto;
  margin-top: 3%;
  text-align: center;
  border: 7px solid rgb(225, 245, 248);
  background: rgba(17, 206, 239, 0.877);
  background-clip:content-box;
  border-radius: 22px;
  padding: 3px;
  margin-bottom: 16px;
  // position: absolute;
  // left: 50%;

  input{
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 95%;
    margin-top: 8px;
    // padding: 4px;
  }

  img {
    width: 95%;
    height: 60px;
    border: 1px solid white;
    border-radius: 8px;
    margin-top: 12px;
    background-color: white;
    display: block;
    margin-left: auto;
    margin-right: auto;

  }

  #login-button{
    padding: 0 32px;
  }
}
#VueCaptcha.vue-captcha{
  border-radius: 13px;

}
.options button{
  justify-content: center;
  box-sizing:content-box;
  border-radius: 2px ;
}

.content-ok small{
  visibility: hidden;
}

.content-ok small::before{
  visibility: visible;
  position: absolute;
  content: 'Sucesso!';
  text-align: center;

}

/* BASIC */

html {
  background-color: rgb(23, 43, 77);
}

body .login {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

.login a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

.login h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
}

/* STRUCTURE */

.login.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login #formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  margin-top: 100px;
  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #007dbe;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

h1 {
  color: #60a0ff;
}

@media (max-width: 768px) {
  .login .form-signin {
    width: 90%;
  }
  .login.wrapper {
    margin-top: 30px;
  }
}
</style>
